import { CloseButton as MantineCloseButton } from '@mantine/core';
import CrossGradientIcon from '../../assets/icons/cross-gradient-icon.svg?react';

export const CloseButton = MantineCloseButton.extend({
	defaultProps: {
		icon: <CrossGradientIcon />,
	},
});
